import { ColumnDataType } from '../types'
import { EnrichComponentDatabricks } from './common/enrichcomponent_db'

class EnrichQuadbinDatabricks extends EnrichComponentDatabricks {
  constructor() {
    super(
      {
        name: 'native.quadbinenrich',
        group: 'Data Enrichment',
        title: 'Enrich Quadbin Grid',
        description: `
      This uses a data source to enrich a target Quadbin table.
      `,
        starred: true
      },
      'quadbin',
      [ColumnDataType.Number],
      (x) => `ST_GEOMFROMTEXT(QUADBIN_BOUNDARY(${x}))`,
      false
    )
  }
}

export { EnrichQuadbinDatabricks }
